var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationIconBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9132 12.4091C22.9132 20.5051 12.4566 27.4444 12.4566 27.4444C12.4566 27.4444 2 20.5051 2 12.4091C2 9.64843 3.10168 7.00084 5.06267 5.04875C7.02367 3.09667 9.68335 2 12.4566 2C15.2299 2 17.8896 3.09667 19.8506 5.04875C21.8116 7.00084 22.9132 9.64843 22.9132 12.4091Z",
    stroke: "#2E2D2B",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4567 15.8788C14.3817 15.8788 15.9423 14.3253 15.9423 12.4091C15.9423 10.4928 14.3817 8.93938 12.4567 8.93938C10.5317 8.93938 8.97118 10.4928 8.97118 12.4091C8.97118 14.3253 10.5317 15.8788 12.4567 15.8788Z",
    stroke: "#2E2D2B",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconBlack);
export default __webpack_public_path__ + "static/media/location_icon_black.9dc9e4873d94951dfa3151eeaf4f5dbc.svg";
export { ForwardRef as ReactComponent };